import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IGhatReceiptDetail } from "../ghatReceiptModel";
import moment from "moment";

export const createGhatReceipt = createAsyncThunk(
  "GhatReceipt/NewInsertGhatReceipt",
  async (ghatReceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/NewInsertGhatReceipt`,
        ghatReceipt,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching GhatReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateGhatReceipt = createAsyncThunk(
  "GhatReceipt/NewUpdateGhatReceipt",
  async (ghatReceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/NewUpdateGhatReceipt`,
        ghatReceipt,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat Redceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllGhatReceipt = createAsyncThunk(
  "GhatReceipt/FindAllGhatReceipt",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/FindAllGhatReceipt`,
        formData,
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fatching GhatReceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteGhatReceipt = createAsyncThunk(
  "GhatReceipt/DeleteGhatReceipt",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/DeleteGhatReceipt`,
        { ghat_receipt_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Delete Ghat Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getGhatReceiptById = createAsyncThunk(
  "GhatReceipt/NewFindByIDGhatReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/NewFindByIDGhatReceipt`,
        { ghat_receipt_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        ghat_receipt_guid: result.ghat_receipt_guid,
        karigar_id: result.karigar_id,
        receipt_no: result.receipt_no,
        karigar_name: result.karigar_name,
        receipt_date: result.receipt_date
          ? moment(result.receipt_date, "YYYY-MM-DD").toDate()
          : "",
        ghat_receipt_order: result.ghat_receipt_order
          ? result.ghat_receipt_order?.map((item: any) => ({
              ...item,
              issize: item.issize ? item.issize : false,
              isweight: item.isweight ? item.isweight : false,
              isdesign: item.isdesign ? item.isdesign : false,
              iscaret: item.iscaret ? item.iscaret : false,
              isgoldcolor: item.isgoldcolor ? item.isgoldcolor : false,
              iseverythingasdescription: item.iseverythingasdescription
                ? item.iseverythingasdescription
                : false,
              ispolishcolor: item.ispolishcolor ? item.ispolishcolor : false,
              isfinishorder: item.isfinishorder ? item.isfinishorder : false,
            }))
          : [],
      } as IGhatReceiptDetail;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteGhatReceiptOrderItem = createAsyncThunk(
  "GhatReceipt/DeleteGhatReceiptProcess",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/DeleteGhatReceiptProcess`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghat Receipt Process:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteGhatReceiptApprovalItem = createAsyncThunk(
  "GhatReceipt/DeleteGhatReceiptApprovedItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/DeleteGhatReceiptApprovedItem`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghat Receipt Process:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteGhatReceiptUsedByKarigarItem = createAsyncThunk(
  "GhatReceipt/DeleteGhatReceiptIssuedByKarigarItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/DeleteGhatReceiptIssuedByKarigarItem`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghat Receipt Process:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByOrderNoGhatReceipt = createAsyncThunk(
  "GhatReceipt/FindByOrderNoGhatReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/FindByOrderNoGhatReceipt`,
        formdata,
      );
      const result = response.data?.Data as any;
      return {
        order_no: result.order_no,
        order_id: result.order_id,
        item_id: result.item_id,
        ghat_id: result.ghat_id,
        item_name: result.item_name,
        item_description: result.item_description,
        item_category_id: result.item_category_id,
        subcategory_name: result.subcategory_name,
        category_name: result.category_name,
        weight: result.weight,
        purity_id: result.purity_id,
        order_vepari_remark: result.remark,
        order_issue_remarks: result.remarks,
        order_process_description: result.process_description,
        item_image: result.item_image,
        approval_items: result.approval_items,
        sizedetails: result.sizedetails,
        size: result.size,
        order_date: result.order_date,
        delivery_date: result.delivery_date,
        order_estimate_weight: result.order_estimate_weight,
        color: result.color,
        karigar_name: result.karigar_name,
        given_date: result.given_date,
        priority: result.priority,
        receive_date: result.receive_date,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllOrderGhatIssue = createAsyncThunk(
  "GhatReceipt/FindAllOrderNoGhatReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/FindAllOrderNoGhatReceipt`,
        formdata,
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Deleting Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const GhatReceiptImageUpdate = createAsyncThunk(
  "GhatReceipt/GhatReceiptImageUpdate",
  async (ghatReceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/GhatReceiptImageUpdate`,
        ghatReceipt,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat Redceipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteGhatReceiptImage = createAsyncThunk(
  "GhatReceipt/DeleteGhatReceiptImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/DeleteGhatReceiptImage`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ghat Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
